import { render, staticRenderFns } from "./SuiteTypeSelectModel.vue?vue&type=template&id=5c71e152&scoped=true"
import script from "./SuiteTypeSelectModel.vue?vue&type=script&lang=js"
export * from "./SuiteTypeSelectModel.vue?vue&type=script&lang=js"
import style0 from "./SuiteTypeSelectModel.vue?vue&type=style&index=0&id=5c71e152&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c71e152",
  null
  
)

export default component.exports